export default __webpack_public_path__ + "img/1bb45b8b5cd4442a8d63d150e0fad307.svg";